import { InvoicePaymentsResponse } from '@commenda/types/src/root-fi/types';
import {
  SWRFetcher,
  serializeRootFiInvoicePaymentsData,
} from '@commenda/utils';
import { DateRange } from 'react-day-picker';
import useSWR, { KeyedMutator } from 'swr';

export function useInvoicePayments(
  rootFiCompanyId: number,
  token: string,
  date: DateRange
) {
  const {
    data,
    error,
    mutate,
  }: {
    mutate: KeyedMutator<unknown>;
    error: unknown;
    data: InvoicePaymentsResponse;
  } = useSWR(
    `rootFi/invoice-payments/${rootFiCompanyId}?from=${date.from}&to=${date.to}`,
    SWRFetcher({ method: 'GET' }, token)
  );

  const serializedInvoicePayments = serializeRootFiInvoicePaymentsData(data);

  return {
    data: serializedInvoicePayments,
    error,
    mutate,
  };
}
